<template>
    <div class="myipt">
        <input :min="min"  :max="max" class="numer-tool" type="number" v-model="val" @input="inputNumber">
    </div>
</template>
<script>
export default {
    props:['max','min','value','precision','xb','name'],
    data(){
        return{
      
            val:this.value
        }
    },
    methods:{
        clear(){
            this.val = ''
            this.$emit('clear')
        },
        inputNumber(e){
    
            let val = Number(e.target.value)
      
            if(this.precision==0){
                if(Number(val)<this.min||Number(val)>this.max){
                    this.$DonMessage.warning(`只能输入${this.min}-${this.max}的正整数`)
                    this.val = ''
                   
                }
                
                if(val.toString().indexOf('.')!=-1){
                    
                    this.$DonMessage.warning(`只能输入${this.min}-${this.max}的正整数`)
                    this.val = ''
                   
                }
            }
            
            if(this.precision==2){
                if(val<this.min||val>this.max){
                    this.$DonMessage.warning(`只能输入${this.min}-${this.max}数字，小数点后只能保留两位`)
                    this.val = ''
                  
                }
                if(val.toString().indexOf('.')!=-1){
                    if(val.toString().slice(val.toString().indexOf('.')+1).length>2){
                        this.val = val.toString().slice(0,val.toString().indexOf('.')+3)
                        this.$DonMessage.warning(`只能输入${this.min}-${this.max}数字，小数点后只能保留两位`)
                    }
                }
             
            }
            let num;
            this.val==''?num='':num= Number(this.val)
            this.$emit('input',num,this.xb,this.name )
           

        }
    }
}
</script>
<style lang="scss" scoped>
.myipt{
    .numer-tool{
        border: 1px solid #DCDFE6;
        font-size: 16px;
        color: #333;
        line-height: 16px;
        padding: 6px 5px;
        width: 100px;
       
        text-align: center;
        box-sizing: border-box;
        border-radius: 2px;
    }
    /* 普通IE浏览器 样式清除 */
     input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{
         -webkit-appearance: none !important;
     }
     /* 火狐浏览器样式清除 */
     input[type="number"]{
         -moz-appearance:textfield;
     }
}


</style>